module.exports = __webpack_public_path__ + "img/services.614ba3ae.jpg";